import React from "react";
import { Route, Switch } from "react-router-dom";
import Guidances from "./guidances/guidances";
import RecycleBin from "./recycleBin/recycleBin";
import MassUpload from "./massUpload/massUpload";
import LegalStatement from "./legalStatement/LegalStatement";

export default function CommonPage() {
  return (
    <Switch>
      <Route path="/common/guidances" component={Guidances} />
      <Route path="/common/legalStatement" component={LegalStatement} />
      <Route path="/common/recyclebin" component={RecycleBin} />
      <Route path="/common/mass-upload" component={MassUpload} />
    </Switch>
  );
}
